import './sass/main.scss'
import menu from './js/menu'
import modal from './js/modal'
import svgxuse from './js/svgxuse'


menu()
modal()
svgxuse()


